export default __webpack_public_path__ + "static/media/fondo_inversion_actions.9bb9af0e.png";